import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import api from "./services/api";
import Home from "./screens/Home";
import Login from "./screens/Login";
import Register from "./screens/Register";
import ForgotPassword from "./screens/ForgotPassword";
import ResetPassword from "./screens/ResetPassword";
import Suppliers from "./screens/Suppliers";
import SupplierDetail from "./screens/SupplierDetail";
import Services from "./screens/Services";
import Invoices from "./screens/Invoices";
import ServiceDetail from "./screens/ServiceDetail";
import ServiceReadings from "./screens/ServiceReadings";
import ServiceInvoices from "./screens/ServiceInvoices";
import ServiceReadingTemplates from "./screens/ServiceReadingTemplates";
import ServiceInvoiceTemplates from "./screens/ServiceInvoiceTemplates";import ServiceActions from './screens/ServiceActions';import Profile from "./screens/Profile";
import Reminders from "./screens/Reminders";
import Notifications from "./screens/Notifications";
import ApiKeys from "./screens/ApiKeys";
import InviteCodes from "./screens/InviteCodes";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import GuestRoute from "./components/GuestRoute";
import UpdatePrompt from "./components/ui/UpdatePrompt";
import { LangProvider } from "./lang/LangContext";
import { CurrencyProvider } from "./context/CurrencyContext";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

const App = () => {
    const [csrfReady, setCsrfReady] = useState(false);

    useEffect(() => {
        api.csrfCookie().then(() => setCsrfReady(true)).catch(() => setCsrfReady(true));
    }, []);

    if (!csrfReady) return null;

    return (
        <LangProvider>
        <CurrencyProvider>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Routes>
                    <Route element={<AuthenticatedRoute />}>
                        <Route index element={<Home />} />
                        <Route path="suppliers" element={<Suppliers />} />
                        <Route path="suppliers/:id" element={<SupplierDetail />} />
                        <Route path="services" element={<Services />} />
                        <Route path="services/:uid" element={<ServiceDetail />} />
                        <Route path="services/:uid/readings" element={<ServiceReadings />} />
                        <Route path="services/:uid/invoices" element={<ServiceInvoices />} />
                        <Route path="services/:uid/reading-templates" element={<ServiceReadingTemplates />} />
                        <Route path="services/:uid/invoice-templates" element={<ServiceInvoiceTemplates />} />
                        <Route path="services/:uid/actions" element={<ServiceActions />} />
                        <Route path="invoices" element={<Invoices />} />
                        <Route path="reminders" element={<Reminders />} />
                        <Route path="notifications" element={<Notifications />} />
                        <Route path="profile" element={<Profile />} />
                        <Route path="api-keys" element={<ApiKeys />} />
                        <Route path="invite-codes" element={<InviteCodes />} />
                    </Route>

                    <Route element={<GuestRoute />}>
                        <Route path="login" element={<Login />} />
                        <Route path="register" element={<Register />} />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                        <Route path="reset-password" element={<ResetPassword />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <UpdatePrompt />
        </QueryClientProvider>
        </CurrencyProvider>
        </LangProvider>
    );
};

export default App;